import React, { useEffect, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import {
  Button,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  TextField,
  Checkbox,
} from '@mui/material';
import { MaterialReactTable } from 'material-react-table';

import { apiGet, apiPutForm, apiDelete, apiPostForm } from '../../../functions/api';
import Layout from '../../../components/layout/layout';

import AsignarEquipo from './Modales/AsignarEquipo';
import EditarEquipo from './Modales/EditarEquipo';
import AgregarEquipo from './Modales/AgregarEquipo';
import VerHistorial from './Modales/VerHistorial';
import EstatusEquipo from './Modales/EstatusEquipo';

import TouchAppIcon from '@mui/icons-material/TouchApp';
import EditIcon from '@mui/icons-material/Edit';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ReplayIcon from '@mui/icons-material/Replay';
import HistoryIcon from '@mui/icons-material/History';
import DeleteIcon from '@mui/icons-material/Delete';
import RefreshIcon from '@mui/icons-material/Refresh';
import TuneIcon from '@mui/icons-material/Tune';
import GroupWorkIcon from '@mui/icons-material/GroupWork';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export default function Equipos() {
  const auth = useSelector((state) => state.authUser.access_token);

  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 10 });
  const [inventarioOriginal, setInventarioOriginal] = useState([]);
  const [data, setData] = useState([]);
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [filterMode, setFilterMode] = useState('all');
  const [filters, setFilters] = useState({
    marca: '',
    equipo: '',
    modelo: '',
    serie: '',
    descripcion: '',
    disponible: '',
    estatus: '',
  });

  const [showFilters, setShowFilters] = useState(false);

  const [modal, setModal] = useState({
    asignar: { show: false, data: null },
    editar: { show: false, data: null },
    agregar: { show: false, data: null },
    historial: { show: false, data: null },
    reasignar: { show: false, data: null },
    estatus: { show: false, data: null },
  });

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  // ✅ selección múltiple (para agrupar)
  const [selectedMap, setSelectedMap] = useState({});
  const selectedList = useMemo(() => Object.values(selectedMap), [selectedMap]);

  const toggleSelectRaw = (raw) => {
    if (!raw?.id) return;
    setSelectedMap((prev) => {
      const next = { ...prev };
      if (next[raw.id]) delete next[raw.id];
      else next[raw.id] = raw;
      return next;
    });
  };

  const clearSelection = () => setSelectedMap({});

  const open = Boolean(anchorEl);
  const prop = { pathname: '/rh/equipos-computo' };

  // ✅ desplegables por grupo (por empleado)
  const [openGroups, setOpenGroups] = useState({}); // { [key]: true }

  const toggleGroup = (key) => {
    setOpenGroups((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const estatusNoDisponible = ['vendido', 'dañado', 'reparación', 'robado'];

  const getDisponibleReal = (item) => {
    const estatusEsNoDisponible = estatusNoDisponible.includes(String(item?.estatus || '').toLowerCase());
    return item?.disponible && !estatusEsNoDisponible ? 'Disponible' : 'No disponible';
  };

  const matchesFilters = (item, f) => {
    if (f.marca && !item.nombre?.toLowerCase().includes(f.marca.toLowerCase())) return false;
    if (f.equipo && !item.tipo?.toLowerCase().includes(f.equipo.toLowerCase())) return false;
    if (f.modelo && !item.modelo?.toLowerCase().includes(f.modelo.toLowerCase())) return false;
    if (f.serie && !item.serie?.toLowerCase().includes(f.serie.toLowerCase())) return false;
    if (f.descripcion && !item.descripcion?.toLowerCase().includes(f.descripcion.toLowerCase())) return false;
    if (f.estatus && item.estatus !== f.estatus) return false;
    return true;
  };
  const pickPrincipal = (raws = []) => {
    if (!raws.length) return { principal: null, accesorios: [] };

    // ✅ PRINCIPAL REAL: id === grupo_principal_id
    let principal = raws.find(
      (r) => Number(r?.id) === Number(r?.grupo_principal_id)
    );

    // 🔁 fallback 1: si por alguna razón no viene bien, intenta el "id apuntado"
    if (!principal) {
      const pid = raws.find((r) => r?.grupo_principal_id)?.grupo_principal_id;
      principal = raws.find((r) => Number(r?.id) === Number(pid));
    }

    // 🔁 fallback 2: datos viejos (antes usabas null)
    if (!principal) {
      principal =
        raws.find((r) => r?.grupo_principal_id === null || r?.grupo_principal_id === undefined) ||
        raws[0];
    }

    const accesorios = raws.filter((r) => Number(r?.id) !== Number(principal?.id));
    return { principal, accesorios };
  };

  const calcDisponibleEmpleado = (allRaws = []) => {
    if (!allRaws.length) return '—';
    const estados = allRaws.map(getDisponibleReal);
    const tieneDisp = estados.includes('Disponible');
    const tieneNo = estados.includes('No disponible');
    if (tieneDisp && tieneNo) return 'Mixto';
    return tieneNo ? 'No disponible' : 'Disponible';
  };

  const exportToExcel = (rowsEmpleado) => {
    const rows = [];

    rowsEmpleado.forEach((empRow) => {
      const asignado = empRow?.asignado || 'N/A';

      // grupos
      (empRow?.grupos || []).forEach((g) => {
        const gid = g?.grupo_id || '—';
        const all = [];
        if (g?.principal) all.push(g.principal);
        if (Array.isArray(g?.accesorios)) all.push(...g.accesorios);

        all.forEach((raw) => {
          rows.push({
            Asignado: asignado,
            Grupo: gid,
            Disponibilidad: getDisponibleReal(raw),
            Marca: raw?.nombre || 'N/A',
            Equipo: raw?.tipo || 'N/A',
            Modelo: raw?.modelo || 'N/A',
            Serie: raw?.serie || 'N/A',
            Descripción: raw?.descripcion || 'N/A',
            Estatus: raw?.estatus || 'N/A',
            'Fecha de compra': raw?.fecha_compra?.slice(0, 10) || 'N/A',
            'Fecha de garantía': raw?.fecha_garantia?.slice(0, 10) || 'N/A',
          });
        });
      });

      // individuales
      (empRow?.individuales || []).forEach((raw) => {
        rows.push({
          Asignado: asignado,
          Grupo: '—',
          Disponibilidad: getDisponibleReal(raw),
          Marca: raw?.nombre || 'N/A',
          Equipo: raw?.tipo || 'N/A',
          Modelo: raw?.modelo || 'N/A',
          Serie: raw?.serie || 'N/A',
          Descripción: raw?.descripcion || 'N/A',
          Estatus: raw?.estatus || 'N/A',
          'Fecha de compra': raw?.fecha_compra?.slice(0, 10) || 'N/A',
          'Fecha de garantía': raw?.fecha_garantia?.slice(0, 10) || 'N/A',
        });
      });
    });

    const worksheet = XLSX.utils.json_to_sheet(rows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Equipos');
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(blob, 'equipos.xlsx');
  };

  
  const processData = (inventario, mode = 'all', f = {}) => {
    const empleados = {};
  

    const ensureEmpleado = (empleado, baseKeyOverride) => {
      const baseKey = baseKeyOverride || (empleado?.id ? `EMP-${empleado.id}` : 'EMP-NA');

      if (!empleados[baseKey]) {
        empleados[baseKey] = {
          baseKey,
          empleado_id: empleado?.id || null,
          asignadoBase: empleado
            ? `${empleado.nombre} ${empleado.apellido_paterno} ${empleado.apellido_materno}`
            : 'N/A',
          buckets: {}, 
        };
      }
      return empleados[baseKey];
    };


    const ensureBucket = (empEntry, disp) => {
      if (!empEntry.buckets[disp]) {
        empEntry.buckets[disp] = {
          disponible: disp,
          gruposMap: {},     
          individuales: [],
          rawsAll: [],
        };
      }
      return empEntry.buckets[disp];
    };

    inventario.forEach((item, idx) => {
      const empleado = item.asigna?.empleado || null;

      if (mode === 'noAsignados' && empleado) return;
      if (!matchesFilters(item, f)) return;

      const disp = getDisponibleReal(item); // 'Disponible' | 'No disponible'
      const gid = item?.grupo_id;

      // ✅ N/A Disponible:
      // - si trae grupo_id => agrupar por grupo
      // - si NO trae grupo_id => NO agrupar (uno por item)
      const baseKeyOverride =
        !empleado && disp === 'Disponible'
          ? (gid
            ? `EMP-NA-GRP-${gid}`
            : `EMP-NA-ITEM-${item.id ?? item.inventario_id ?? item.uuid ?? idx}`
          )
          : undefined;

      const empEntry = ensureEmpleado(empleado, baseKeyOverride);
      const bucket = ensureBucket(empEntry, disp);

      bucket.rawsAll.push(item);

      // ✅ aquí se sigue agrupando por grupo_id normal
      if (gid) {
        if (!bucket.gruposMap[gid]) bucket.gruposMap[gid] = { grupo_id: gid, raws: [] };
        bucket.gruposMap[gid].raws.push(item);
      } else {
        bucket.individuales.push(item);
      }
    });


    const out = [];

    Object.values(empleados).forEach((empEntry) => {
      const bucketKeys = Object.keys(empEntry.buckets);
      const tieneAmbos = bucketKeys.length > 1;

    
      bucketKeys
        .sort((a, b) => (a === b ? 0 : a === 'Disponible' ? -1 : 1))
        .forEach((disp) => {
          const b = empEntry.buckets[disp];

          const grupos = Object.values(b.gruposMap)
            .map((g) => {
              const raws = Array.isArray(g.raws) ? [...g.raws] : [];
              const { principal, accesorios } = pickPrincipal(raws);
              return { grupo_id: g.grupo_id, principal, accesorios };
            })
            .sort((a, b) => String(a.grupo_id).localeCompare(String(b.grupo_id)));
          const individuales = Array.isArray(b.individuales) ? [...b.individuales] : [];

          const grupo_label =
            grupos.length === 0
              ? '—'
              : grupos.length === 1
                ? grupos[0].grupo_id
                : `${grupos[0].grupo_id} (+${grupos.length - 1})`;

          out.push({
          
            asignado: tieneAmbos ? `${empEntry.asignadoBase} (${disp})` : empEntry.asignadoBase,

            grupo_label,
            disponible: disp,

            grupos,
            individuales,
            rawsAll: b.rawsAll,
          });
        });
    });

 
    out.sort((a, b) => {
      const aHasGroups = (a.grupos?.length || 0) > 0;
      const bHasGroups = (b.grupos?.length || 0) > 0;

      const aHasInd = (a.individuales?.length || 0) > 0;
      const bHasInd = (b.individuales?.length || 0) > 0;

      const aNA = !a.empleado_id;
      const bNA = !b.empleado_id;

      const rank = (x) => {
        const isNA = !x.empleado_id;

    
        if (isNA && x.disponible === 'Disponible') return 0;

     
        if (!isNA && (x.grupos?.length || 0) > 0) return 1;
        if (!isNA && (x.individuales?.length || 0) > 0) return 2;

        return 3;
      };

      const ra = rank(a);
      const rb = rank(b);
      if (ra !== rb) return ra - rb;

  
      const clean = (s) => String(s).replace(/\s\((Disponible|No disponible)\)$/, '');
      const an = clean(a.asignado);
      const bn = clean(b.asignado);
      const c = an.localeCompare(bn);
      if (c !== 0) return c;

  
      if (a.disponible !== b.disponible) return a.disponible === 'Disponible' ? -1 : 1;

      // estable final
      if (aNA !== bNA) return aNA ? -1 : 1;

      return 0;
    });

    return out;
  };

  const fetchEquipos = async () => {
    setIsLoading(true);
    try {
      const res = await apiGet('equipos/equipos', auth);
      const inventarioOrdenado = res.data.inventario.sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );
      setInventarioOriginal(inventarioOrdenado);
      setUsers(res.data.usuarios);
    } catch (error) {
      console.error('Error al cargar inventario:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => { fetchEquipos(); }, []);

  useEffect(() => {
    setData(processData(inventarioOriginal, 'filtered', filters));
  }, [inventarioOriginal, filters]);

  const handleFilterChange = (field, value) => {
    const updatedFilters = { ...filters, [field]: value };
    const allEmpty = Object.values(updatedFilters).every((v) => !v);

    if (allEmpty) setFilterMode('all');
    else setFilterMode('filtered');

    setFilters(updatedFilters);
    setPagination((prev) => ({ ...prev, pageIndex: 0 }));
  };

  const handleOpenModal = (tipo, item = null) =>
    setModal((prev) => ({ ...prev, [tipo]: { show: true, data: item } }));

  const handleCloseModal = (tipo) =>
    setModal((prev) => ({ ...prev, [tipo]: { show: false, data: null } }));

  const handleMenuOpen = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };

  const handleUnassignGrupo = async (grupo_id) => {
    try {
      await apiPostForm(`equipos/desasignar-grupo`, { grupo_id }, auth);
      Swal.fire({ icon: 'success', title: 'Grupo desasignado', showConfirmButton: false, timer: 1500 });
      fetchEquipos();
    } catch (error) {
      console.error(error);
      Swal.fire('Error al desasignar grupo', '', 'error');
    }
  };

  const handleUnassignEquipo = async (equipo) => {
    try {
      await apiPutForm(`equipos/desasignar/${equipo.id}`, { equipo: equipo.id }, auth);
      Swal.fire({ icon: 'success', title: 'Equipo desasignado', showConfirmButton: false, timer: 1500 });
      fetchEquipos();
    } catch (error) {
      console.error(error);
      Swal.fire('Error al desasignar', '', 'error');
    }
  };
  const handleQuitarDeGrupo = async (row) => {
    try {
      if (!row?.grupo_id) {
        Swal.fire('No pertenece a un grupo', '', 'info');
        return;
      }

      const esPrincipal = Number(row.id) === Number(row.grupo_principal_id);

      // Si es principal, ofrece 2 opciones
      if (esPrincipal) {
        const res = await Swal.fire({
          title: 'Este es el PRINCIPAL del grupo',
          text: '¿Qué quieres hacer?',
          icon: 'question',
          showCancelButton: true,
          showDenyButton: true,
          confirmButtonText: 'Sacar solo este (promover otro principal)',
          denyButtonText: 'Disolver grupo completo',
          cancelButtonText: 'Cancelar',
        });

        if (res.isDenied) {
          await apiPostForm(`equipos/grupos/disolver`, { grupo_id: row.grupo_id }, auth);
          Swal.fire('Listo', 'Grupo disuelto', 'success');
          fetchEquipos();
          return;
        }

        if (!res.isConfirmed) return;

        await apiPutForm(`equipos/grupos/quitar/${row.id}`, {}, auth);
        Swal.fire('Listo', 'Principal quitado y se eligió otro principal', 'success');
        fetchEquipos();
        return;
      }

      // Accesorio normal
      const ok = await Swal.fire({
        title: '¿Sacar del grupo?',
        text: `Se quitará este equipo del grupo ${row.grupo_id}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, sacar',
        cancelButtonText: 'Cancelar',
      });

      if (!ok.isConfirmed) return;

      await apiPutForm(`equipos/grupos/quitar/${row.id}`, {}, auth);
      Swal.fire('Listo', 'Equipo quitado del grupo', 'success');
      fetchEquipos();
    } catch (error) {
      console.error(error);
      Swal.fire('Error', error?.response?.data?.message || 'Ocurrió un error', 'error');
    }
  };

  const handleDeleteEquipo = async (equipo) => {
    if (equipo && !equipo.disponible) {
      Swal.fire('No puedes eliminar este equipo', 'Primero desasigna el equipo antes de eliminarlo.', 'warning');
      return;
    }
    Swal.fire({
      title: '¿Estás seguro?',
      text: '¡Esta acción eliminará el equipo!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await apiDelete(`equipos/${equipo.id}`, auth);
          Swal.fire({ icon: 'success', title: 'Equipo eliminado', showConfirmButton: false, timer: 1500 });
          fetchEquipos();
        } catch (error) {
          console.error(error);
          Swal.fire('Error al eliminar', '', 'error');
        }
      }
    });
  };

  const handleOpenHistorial = (item) => {
    const actualizado = inventarioOriginal.find((e) => e.id === item.id);
    handleOpenModal('historial', actualizado || item);
  };

  const handleAgruparSeleccion = async () => {
    if (selectedList.length < 2) return;

    const optionsHtml = selectedList
      .map((x) => {
        const label = `${x.tipo || 'Equipo'} | ${x.nombre || '—'} | ${x.modelo || '—'} | ${x.serie || '—'}`;
        return `<option value="${x.id}">${label}</option>`;
      })
      .join('');

    const { value: formValues } = await Swal.fire({
      title: 'Agrupar equipos',
      html: `
      <div style="text-align:left; margin-bottom:10px;">
        <div style="font-size:13px; margin-bottom:6px;">Selecciona el <b>equipo principal</b> (ej. la laptop):</div>
        <select id="principal_select" class="swal2-select" style="width:100%;">
          ${optionsHtml}
        </select>
      </div>

      <div style="text-align:left;">
        <div style="font-size:13px; margin-bottom:6px;">Grupo ID (opcional, si lo dejas vacío se genera):</div>
        <input id="grupo_input" class="swal2-input" placeholder="Ej: LAPTOP-J-001" />
      </div>
    `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: 'Agrupar',
      cancelButtonText: 'Cancelar',
      preConfirm: () => {
        const principal_id = Number(document.getElementById('principal_select')?.value || 0);
        const grupo_id = document.getElementById('grupo_input')?.value?.trim() || null;
        if (!principal_id) {
          Swal.showValidationMessage('Selecciona un equipo principal');
          return null;
        }
        return { principal_id, grupo_id };
      },
    });

    if (!formValues) return;

    const inventario_ids = selectedList.map((x) => x.id);

    try {
      const res = await apiPostForm(
        'equipos/grupos/asignar',
        {
          inventario_ids,
          principal_id: formValues.principal_id,
          grupo_id: formValues.grupo_id,
        },
        auth
      );

      const grupoGenerado = res?.data?.grupo_id || res?.grupo_id || formValues?.grupo_id || '—';
      Swal.fire('Listo', `Grupo: ${grupoGenerado}`, 'success');

      clearSelection();
      fetchEquipos();
    } catch (error) {
      console.error(error);
      Swal.fire('Error al agrupar', error?.response?.data?.message || '', 'error');
    }
  };

  // ✅ helper UI: fila (principal/accesorio/individual) + botón desplegable
  const renderRawRow = ({
    raw,
    rowKey,
    isPrincipal = false,
    isAccesorio = false,
    isGroupHeader = false,
    groupToggle = null,
    groupOpen = false,
    showToggle = false,
    onActionClick,
  }) => {
    const marca = raw?.nombre || 'N/A';
    const equipo = raw?.tipo || 'N/A';
    const modelo = raw?.modelo || 'N/A';
    const serie = raw?.serie || 'N/A';
    const desc = raw?.descripcion || 'N/A';
    const est = raw?.estatus || 'N/A';

    const equipoLabel = isPrincipal
      ? `PRINCIPAL → ${equipo}`
      : isAccesorio
        ? `→ ${equipo}`
        : equipo;

    const marcaLabel = isPrincipal ? `→ ${marca}` : marca;

    return (
      <div
        key={rowKey}
        style={{
          display: 'flex',
          alignItems: 'center',
          borderBottom: '1px solid #ddd',
          padding: '2px 0',
          background: '#fff',
        }}
      >
        <div style={{ width: '44px', textAlign: 'center' }}>
          <Checkbox
            size="small"
            checked={Boolean(selectedMap[raw?.id])}
            onChange={() => toggleSelectRaw(raw)}
          />
        </div>

        <div style={{ width: '70px', textAlign: 'center', display: 'flex', justifyContent: 'center', gap: 6 }}>
          {showToggle ? (
            <IconButton size="small" onClick={groupToggle}>
              {groupOpen ? <KeyboardArrowDownIcon fontSize="small" /> : <KeyboardArrowRightIcon fontSize="small" />}
            </IconButton>
          ) : null}

          <IconButton size="small" onClick={onActionClick}>
            <TouchAppIcon fontSize="small" style={{ color: '#1976d2' }} />
          </IconButton>
        </div>

        <div style={{ width: '120px', textAlign: 'center', fontWeight: isPrincipal ? 900 : 500 }}>
          {equipoLabel}
        </div>

        <div style={{ width: '120px', textAlign: 'center', fontWeight: isPrincipal ? 900 : 500 }}>
          {marcaLabel}
        </div>

        <div style={{ width: '120px', textAlign: 'center' }}>{modelo}</div>
        <div style={{ width: '120px', textAlign: 'center' }}>{serie}</div>
        <div style={{ flex: 1, textAlign: 'center', whiteSpace: 'pre-line' }}>{desc}</div>

        <div style={{ width: '100px', textAlign: 'center', flexShrink: 0 }}>
          {est ? <span style={{ fontSize: 12 }}>{est}</span> : <span style={{ color: '#bbb' }}>N/A</span>}
        </div>
      </div>
    );
  };

  const disponibilidadStyle = (value) => {
    if (value === 'Disponible') return { color: 'green', fontWeight: 'bold' };
    if (value === 'No disponible') return { color: 'red', fontWeight: 'bold' };
    if (value === 'Mixto') return { color: '#b26a00', fontWeight: 'bold' };
    return { color: '#777', fontWeight: 'bold' };
  };

  return (
    <Layout authUser={auth} location={prop} history={{ location: prop }} active="rh">
      <MaterialReactTable
        columns={[
          { accessorKey: 'asignado', header: 'Asignado' },

          {
            accessorKey: 'disponible',
            header: 'Disponibilidad',
            Cell: ({ cell }) => {
              const v = cell.getValue();
              return <span style={disponibilidadStyle(v)}>{v}</span>;
            },
          },

          {
            id: 'detalles',
            header: showFilters && (
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 4, gap: 4 }}>
                  <div style={{ width: 70, flexShrink: 0, display: 'flex', justifyContent: 'center' }}>
                    <IconButton
                      size="small"
                      onClick={() => {
                        setFilters({ marca: '', equipo: '', modelo: '', serie: '', descripcion: '', disponible: '', estatus: '' });
                        setFilterMode('all');
                        setPagination({ pageIndex: 0, pageSize: 10 });
                        fetchEquipos();
                        setShowFilters(false);
                      }}
                    >
                      <RefreshIcon fontSize="small" />
                    </IconButton>
                  </div>

                  <div style={{ flex: 1 }}>
                    <TextField placeholder="Marca" size="small" fullWidth value={filters.marca} onChange={(e) => handleFilterChange('marca', e.target.value)} />
                  </div>
                  <div style={{ flex: 1 }}>
                    <TextField placeholder="Equipo" size="small" fullWidth value={filters.equipo} onChange={(e) => handleFilterChange('equipo', e.target.value)} />
                  </div>
                  <div style={{ flex: 1 }}>
                    <TextField placeholder="Modelo" size="small" fullWidth value={filters.modelo} onChange={(e) => handleFilterChange('modelo', e.target.value)} />
                  </div>
                  <div style={{ flex: 1 }}>
                    <TextField placeholder="Serie" size="small" fullWidth value={filters.serie} onChange={(e) => handleFilterChange('serie', e.target.value)} />
                  </div>
                  <div style={{ flex: 2 }}>
                    <TextField placeholder="Descripción" size="small" fullWidth value={filters.descripcion} onChange={(e) => handleFilterChange('descripcion', e.target.value)} />
                  </div>
                  <div style={{ flex: 1 }}>
                    <TextField placeholder="Estatus" size="small" fullWidth value={filters.estatus} onChange={(e) => handleFilterChange('estatus', e.target.value)} />
                  </div>
                </div>
              </div>
            ),

            Cell: ({ row }) => {
              const empKey = row.original?.empleado_key || 'EMP-NA';
              const grupos = row.original?.grupos || [];
              const individuales = row.original?.individuales || [];

              return (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                  {/* header de columnas internas (una sola vez por empleado) */}
                  <div style={{ display: 'flex', fontWeight: 'bold', borderBottom: '2px solid #000', marginBottom: 4 }}>
                    <div style={{ width: 44, textAlign: 'center' }}>SEL</div>
                    <div style={{ width: 70, textAlign: 'center' }}>ACCIONES</div>
                    <div style={{ width: 120, textAlign: 'center' }}>EQUIPO</div>
                    <div style={{ width: 120, textAlign: 'center' }}>MARCA</div>
                    <div style={{ width: 120, textAlign: 'center' }}>MODELO</div>
                    <div style={{ width: 120, textAlign: 'center' }}>SERIE</div>
                    <div style={{ flex: 1, textAlign: 'center' }}>DESCRIPCIÓN</div>
                    <div style={{ width: 100, textAlign: 'center' }}>ESTATUS</div>
                  </div>

                  {/* ✅ GRUPOS (principal visible + accesorios colapsados) */}
                  {grupos.map((g, idx) => {
                    const gid = g?.grupo_id;
                    const principal = g?.principal;
                    const accesorios = Array.isArray(g?.accesorios) ? g.accesorios : [];

                    const groupKey = `${empKey}::${gid}`;
                    const isOpen = Boolean(openGroups[groupKey]);
                    const hasAcc = accesorios.length > 0;

                    return (
                      <div
                        key={groupKey}
                        style={{
                          border: '1px solid #e5e7eb',
                          borderRadius: 8,
                          overflow: 'hidden',
                          marginBottom: 8,
                          background: '#fff',
                        }}
                      >
                        {/* encabezado del grupo */}
                        <div
                          style={{
                            padding: '6px 10px',
                            fontSize: 12,
                            fontWeight: 900,
                            background: '#f3f4f6',
                            borderBottom: '1px solid #e5e7eb',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                          }}
                        >
                          <div>
                            GRUPO: <span style={{ fontWeight: 900 }}>{gid}</span>
                          </div>
                          <div style={{ fontWeight: 700, color: '#555' }}>
                            {hasAcc ? `${accesorios.length} accesorio(s)` : 'sin accesorios'}
                          </div>
                        </div>

                        {/* principal */}
                        {principal
                          ? renderRawRow({
                            raw: principal,
                            rowKey: `${groupKey}::P-${principal.id}`,
                            isPrincipal: true,
                            showToggle: hasAcc,
                            groupOpen: isOpen,
                            groupToggle: () => toggleGroup(groupKey),
                            onActionClick: (e) => handleMenuOpen(e, principal),
                          })
                          : null}

                        {/* accesorios (solo si abierto) */}
                        {hasAcc && isOpen ? (
                          <>
                            <div
                              style={{
                                padding: '6px 10px',
                                fontSize: 12,
                                fontWeight: 900,
                                background: '#fafafa',
                                borderTop: '1px solid #e5e7eb',
                                borderBottom: '1px solid #e5e7eb',
                              }}
                            >
                              ACCESORIOS:
                            </div>

                            {accesorios.map((raw) =>
                              renderRawRow({
                                raw,
                                rowKey: `${groupKey}::A-${raw.id}`,
                                isAccesorio: true,
                                showToggle: false,
                                onActionClick: (e) => handleMenuOpen(e, raw),
                              })
                            )}
                          </>
                        ) : null}
                      </div>
                    );
                  })}

                  {/* ✅ INDIVIDUALES (sin grupo) */}
                  {individuales.length ? (
                    <div style={{ marginTop: 6 }}>
                      <div
                        style={{
                          padding: '6px 10px',
                          fontSize: 12,
                          fontWeight: 900,
                          background: '#f9fafb',
                          border: '1px solid #e5e7eb',
                          borderRadius: 8,
                          marginBottom: 6,
                        }}
                      >
                        INDIVIDUALES:
                      </div>

                      <div style={{ border: '1px solid #e5e7eb', borderRadius: 8, overflow: 'hidden' }}>
                        {individuales.map((raw) =>
                          renderRawRow({
                            raw,
                            rowKey: `${empKey}::I-${raw.id}`,
                            isPrincipal: false,
                            isAccesorio: false,
                            showToggle: false,
                            onActionClick: (e) => handleMenuOpen(e, raw),
                          })
                        )}
                      </div>
                    </div>
                  ) : null}

                  {/* si no hay nada */}
                  {!grupos.length && !individuales.length ? (
                    <div style={{ padding: 10, color: '#777' }}>Sin equipos</div>
                  ) : null}
                </div>
              );
            },
          },
        ]}
        data={data}
        state={{ isLoading, pagination, showColumnFilters: showFilters }}
        onPaginationChange={setPagination}
        onShowColumnFiltersChange={setShowFilters}
        enableColumnOrdering
        enableRowActions={false}
        initialState={{ pagination: { pageSize: 10 } }}
        muiTablePaginationProps={{
          rowsPerPageOptions: [10, 20, 50],
          labelRowsPerPage: 'Equipos por página',
        }}
        enableGlobalFilter={false}
        renderTopToolbarCustomActions={() => (
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
            <IconButton
              onClick={() => {
                fetchEquipos();
                setPagination({ pageIndex: 0, pageSize: 10 });
              }}
            >
              <RefreshIcon fontSize="small" />
            </IconButton>

            <Button variant="contained" onClick={() => handleOpenModal('agregar')}>
              Nuevo equipo
            </Button>

            <Button variant="outlined" onClick={() => exportToExcel(data)}>
              Exportar a Excel
            </Button>

            <Button
              variant="contained"
              color="secondary"
              startIcon={<GroupWorkIcon />}
              disabled={selectedList.length < 2}
              onClick={handleAgruparSeleccion}
            >
              Agrupar ({selectedList.length})
            </Button>

            {selectedList.length > 0 && (
              <Button variant="text" onClick={clearSelection}>
                Limpiar selección
              </Button>
            )}
          </div>
        )}
      />

      {/* Menú acciones */}
      <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose} onClick={handleMenuClose}>
        <MenuItem onClick={() => handleOpenModal('editar', selectedRow)}>
          <ListItemIcon><EditIcon fontSize="small" /></ListItemIcon>
          <ListItemText>Editar</ListItemText>
        </MenuItem>

        <MenuItem onClick={() => { if (selectedRow?.disponible) handleOpenModal('asignar', selectedRow); else Swal.fire('Ya está asignado', '', 'info'); }}>
          <ListItemIcon><AssignmentIcon fontSize="small" /></ListItemIcon>
          <ListItemText>Asignar</ListItemText>
        </MenuItem>

        <MenuItem onClick={() => handleOpenModal('estatus', selectedRow)}>
          <ListItemIcon><TuneIcon fontSize="small" /></ListItemIcon>
          <ListItemText>Estatus</ListItemText>
        </MenuItem>

        <MenuItem onClick={() => { if (!selectedRow?.disponible) handleOpenModal('reasignar', selectedRow); else Swal.fire('Primero asigna el equipo', '', 'info'); }}>
          <ListItemIcon><ReplayIcon fontSize="small" /></ListItemIcon>
          <ListItemText>Reasignar</ListItemText>
        </MenuItem>

        <MenuItem onClick={() => handleOpenHistorial(selectedRow)}>
          <ListItemIcon><HistoryIcon fontSize="small" /></ListItemIcon>
          <ListItemText>Historial</ListItemText>
        </MenuItem>
        {Boolean(selectedRow?.grupo_id) && (
          <MenuItem onClick={() => handleQuitarDeGrupo(selectedRow)}>
            <ListItemIcon><GroupWorkIcon fontSize="small" /></ListItemIcon>
            <ListItemText>Sacar del grupo</ListItemText>
          </MenuItem>
        )}

        <MenuItem
          onClick={() => {
            if (!selectedRow?.disponible) {
              const tieneGrupo = Boolean(selectedRow?.grupo_id);

              if (tieneGrupo) {
                Swal.fire({
                  title: '¿Qué quieres desasignar?',
                  text: 'Puedes desasignar todo el grupo o solo este equipo.',
                  icon: 'question',
                  showCancelButton: true,
                  showDenyButton: true,
                  confirmButtonText: 'Todo el grupo',
                  denyButtonText: 'Solo este equipo',
                  cancelButtonText: 'Cancelar',
                }).then((res) => {
                  if (res.isConfirmed) handleUnassignGrupo(selectedRow.grupo_id);
                  else if (res.isDenied) handleUnassignEquipo(selectedRow);
                });
              } else {
                Swal.fire({
                  title: '¿Estás seguro?',
                  text: 'Esto desasignará el equipo',
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Sí, desasignar',
                  cancelButtonText: 'Cancelar',
                }).then((result) => {
                  if (result.isConfirmed) handleUnassignEquipo(selectedRow);
                });
              }
            } else {
              Swal.fire('Este equipo no está asignado', '', 'info');
            }
          }}
        >
          <ListItemIcon><ReplayIcon fontSize="small" /></ListItemIcon>
          <ListItemText>Desasignar</ListItemText>
        </MenuItem>

        <MenuItem onClick={() => handleDeleteEquipo(selectedRow)}>
          <ListItemIcon><DeleteIcon fontSize="small" /></ListItemIcon>
          <ListItemText>Eliminar</ListItemText>
        </MenuItem>
      </Menu>

      {/* Modales */}
      <AsignarEquipo
        data={modal.asignar.data}
        show={modal.asignar.show}
        handleClose={() => handleCloseModal('asignar')}
        reload={fetchEquipos}
        users={users}
        mode="asignar"
      />

      <AsignarEquipo
        data={modal.reasignar.data}
        show={modal.reasignar.show}
        handleClose={() => handleCloseModal('reasignar')}
        reload={fetchEquipos}
        users={users}
        mode="reasignar"
      />

      <EditarEquipo
        data={modal.editar.data}
        show={modal.editar.show}
        handleClose={() => handleCloseModal('editar')}
        reload={(equipoActualizado) => {
          setInventarioOriginal((prev) => prev.map((e) => (e.id === equipoActualizado.id ? equipoActualizado : e)));
          setData(processData([...inventarioOriginal]));
        }}
      />

      <AgregarEquipo
        show={modal.agregar.show}
        handleClose={() => handleCloseModal('agregar')}
        reload={() => {
          fetchEquipos();
          setPagination({ pageIndex: 0, pageSize: 10 });
        }}
      />

      <VerHistorial
        data={modal.historial.data}
        show={modal.historial.show}
        handleClose={() => handleCloseModal('historial')}
      />

      <EstatusEquipo
        data={modal.estatus.data}
        show={modal.estatus.show}
        handleClose={() => handleCloseModal('estatus')}
        reload={fetchEquipos}
      />
    </Layout>
  );
}
